import axios, { AxiosRequestConfig } from "axios";

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export function addCancelToken(config: AxiosRequestConfig) {
    config.cancelToken = source.token;
    return config;
}

const cancelAllRequests = () => {
    source.cancel();
    source = CancelToken.source();
};

export default cancelAllRequests;
